export const API_PREFIX = '/v1';
export const Routes = {
    health: `${API_PREFIX}/health`,
    version: `${API_PREFIX}/version`,
    authSignup: `${API_PREFIX}/auth/signup`,
    authSignin: `${API_PREFIX}/auth/signin`,
    authKeys: `${API_PREFIX}/auth/keys`,
    authKeysRevoke: (id) => `${API_PREFIX}/auth/keys/${id}`,
    authWhoami: `${API_PREFIX}/auth/whoami`,
    authExport: `${API_PREFIX}/auth/export`,
    authAccount: `${API_PREFIX}/auth/account`,
    projects: `${API_PREFIX}/projects`,
    project: (id) => `${API_PREFIX}/projects/${id}`,
    projectDocuments: (id) => `${API_PREFIX}/projects/${id}/documents`,
    projectEnvironments: (id) => `${API_PREFIX}/projects/${id}/environments`,
    projectSetDefaultEnv: (id, envId) => `${API_PREFIX}/projects/${id}/environments/${envId}/default`,
    projectPreflight: (id) => `${API_PREFIX}/projects/${id}/preflight`,
    environments: `${API_PREFIX}/environments`,
    environment: (id) => `${API_PREFIX}/environments/${id}`,
    tests: `${API_PREFIX}/tests`,
    test: (id) => `${API_PREFIX}/tests/${id}`,
    testsGenerate: `${API_PREFIX}/tests/generate`,
    testCode: (id) => `${API_PREFIX}/tests/${id}/code`,
    testPlan: (id) => `${API_PREFIX}/tests/${id}/plan`,
    testSteps: (id) => `${API_PREFIX}/tests/${id}/steps`,
    testResult: (id) => `${API_PREFIX}/tests/${id}/result`,
    testHistory: (id) => `${API_PREFIX}/tests/${id}/result/history`,
    testFailure: (id) => `${API_PREFIX}/tests/${id}/failure`,
    testRerun: (id) => `${API_PREFIX}/tests/${id}/rerun`,
    testFlaky: (id) => `${API_PREFIX}/tests/${id}/flaky`,
    testDiff: (id) => `${API_PREFIX}/tests/${id}/diff`,
    runs: `${API_PREFIX}/runs`,
    run: (id) => `${API_PREFIX}/runs/${id}`,
    runCancel: (id) => `${API_PREFIX}/runs/${id}/cancel`,
    runWait: `${API_PREFIX}/runs/wait`,
    runArtifact: (runId, artifactId) => `${API_PREFIX}/runs/${runId}/artifacts/${artifactId}`,
    runArchive: (runId) => `${API_PREFIX}/runs/${runId}/artifacts`,
    testlists: `${API_PREFIX}/testlists`,
    testlist: (id) => `${API_PREFIX}/testlists/${id}`,
    testlistCases: (id) => `${API_PREFIX}/testlists/${id}/cases`,
    testlistRun: (id) => `${API_PREFIX}/testlists/${id}/run`,
    schedules: `${API_PREFIX}/schedules`,
    schedule: (id) => `${API_PREFIX}/schedules/${id}`,
    schedulePause: (id) => `${API_PREFIX}/schedules/${id}/pause`,
    scheduleResume: (id) => `${API_PREFIX}/schedules/${id}/resume`,
    scheduleRuns: (id) => `${API_PREFIX}/schedules/${id}/runs`,
    usage: `${API_PREFIX}/usage`,
    events: `${API_PREFIX}/events`,
    agents: `${API_PREFIX}/agents`,
    agentsInstall: `${API_PREFIX}/agents/install`,
    skill: (name) => `${API_PREFIX}/agents/skill/${name}`,
    tunnels: `${API_PREFIX}/tunnels`,
    tunnel: (clientId) => `${API_PREFIX}/tunnels/${clientId}`,
    tunnelStopAll: `${API_PREFIX}/tunnels/stop-all`,
    tunnelControlPlane: '/tunnel/ws',
    tunnelDataPlane: '/tunnel/data',
    billingCheckout: `${API_PREFIX}/billing/checkout`,
    billingWebhook: `${API_PREFIX}/billing/webhook`,
    billingPortal: `${API_PREFIX}/billing/portal`,
    billingCancel: `${API_PREFIX}/billing/cancel`,
    billingSubscription: `${API_PREFIX}/billing/subscription`,
    billingRefresh: `${API_PREFIX}/billing/refresh`,
    adminOverview: `${API_PREFIX}/admin/overview`,
    adminLlm: `${API_PREFIX}/admin/llm`,
    adminLlmModels: `${API_PREFIX}/admin/llm/models`,
    adminOrganizations: `${API_PREFIX}/admin/organizations`,
    adminOrganizationQuota: (id) => `${API_PREFIX}/admin/organizations/${id}/quota`,
    adminOrganizationCredits: (id) => `${API_PREFIX}/admin/organizations/${id}/credits`,
    adminSmtp: `${API_PREFIX}/admin/smtp`,
    adminSmtpTest: `${API_PREFIX}/admin/smtp/test`,
};
/** `X-Verifyloop-Exit-Code` mirrors the CLI's process exit code for HTTP callers. */
export const EXIT_CODE_HEADER = 'x-verifyloop-exit-code';
//# sourceMappingURL=api.js.map